
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import ChipButtons from '@/ui-components/ChipButtons.vue';
import ChipButton from '@/ui-components/ChipButton.vue';

import { TitleObjectType } from '@/interfaces/titles';

import { PlotRecommenderState } from './plot-recommender.store';

const LpPlotRecommender = namespace('LpPlotRecommender');

@Component({
	name: 'PlotRecommenderContentTypeFilter',
	components: { ChipButtons, ChipButton },
})
export default class PlotRecommenderContentTypeFilter extends Vue {
	@LpPlotRecommender.State filters: PlotRecommenderState['filters'];
	@LpPlotRecommender.Mutation SET_FILTER: Function;

	TitleObjectType = TitleObjectType;

	get contentTypes() {
		const contentTypes = this.filters.content_types || [];

		return [
			{
				key: 'WEBAPP_ALL_TITLES',
				translation: this.$tc('WEBAPP_ALL_TITLES'),
				isActive: contentTypes.length === 0,
				value: null,
			},
			{
				key: 'WEBAPP_MOVIES',
				translation: this.$tc('WEBAPP_MOVIES'),
				isActive: contentTypes.includes(TitleObjectType.MOVIE),
				value: TitleObjectType.MOVIE,
			},
			{
				key: 'WEBAPP_TVSHOWS',
				translation: this.$tc('WEBAPP_TVSHOWS'),
				isActive: contentTypes.includes(TitleObjectType.SHOW),
				value: TitleObjectType.SHOW,
			},
		];
	}

	toggle(contentType: TitleObjectType | null) {
		const value = contentType ? [contentType] : [];
		this.SET_FILTER({ key: 'content_types', value });
	}
}
